module.exports = __webpack_public_path__ + "img/background-login.e6fd6100.jpg";